import { createSlice } from "@reduxjs/toolkit"
import {
  addGalleryImages,
  addItem,
  addVideo,
  calculateComboPrice,
  cloneItem,
  deleteItem,
  deleteMultipleItems,
  enableDisableItem,
  getItemsDetails,
  getItemsList,
  getItemsListDropdown,
  removeVideoUrlFromItem,
  updateItem,
  updateItemStatus,
  updateMultipleItems,
} from "store/actions/itemsAction"
import { deleteModifierGroup } from "store/actions/modifierGroupAction"

const initialState = {
  loading: true,
  error: null,
  isLoading: false,
  actionType: null,
  message: null,
  itemsPerPage: 12,
  totalCount: null,
  totalPages: null,
  currentPage: 1,
  isUpdating: false,
  itemsLists: [],
  itemDetails: {},
  itemsListDropdown: [],
}

const usersSlice = createSlice({
  name: "items", //
  initialState,
  reducers: {},
  extraReducers: builder => {
    // FETCH ALL Items
    builder
      .addCase(getItemsList.pending, state => {
        state.loading = true
        state.error = null
        state.actionType = null
      })
      .addCase(getItemsList.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action?.payload

        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.itemsLists = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getItemsList.rejected, (state, action) => {
        state.loading = false
      })

    // GET ALL ITEMS LIST DROPDOWN
    builder
      .addCase(getItemsListDropdown.pending, state => {
        state.error = null
      })
      .addCase(getItemsListDropdown.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action?.payload

        if (status) {
          state.itemsListDropdown = data
        }
      })
      .addCase(getItemsListDropdown.rejected, (state, action) => {})

    // ITEM STATUS UPDATE
    builder
      .addCase(updateItemStatus.pending, state => {
        state.error = null
        state.actionType = null
        state.isUpdating = true
      })
      .addCase(updateItemStatus.fulfilled, (state, action) => {
        state.isUpdating = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          //
          state.itemsLists = state.itemsLists.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
          state.message = action.payload.msg
          state.actionType = "ITEM_UPDATED_SUCCESS"
        } else {
          state.actionType = "ITEM_UPDATED_FAILED"
          state.error = action.payload.msg
        }
      })
      .addCase(updateItemStatus.rejected, (state, action) => {
        state.isUpdating = false
      })

    // ADD ITEM
    builder
      .addCase(addItem.pending, state => {
        state.error = null
        state.isLoading = true
        state.actionType = null
        state.message = null
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          state.actionType = "ITEM_ADDED_SUCCESS"
          state.message = action.payload.msg
          // action.meta.arg.navigate("") //
        } else {
          state.error = action.payload.msg
          state.actionType = "ITEM_ADDED_FAILED"
        }
      })
      .addCase(addItem.rejected, (state, action) => {
        state.isLoading = false
      })

    // FETCH Item Details
    builder
      .addCase(getItemsDetails.pending, state => {
        state.loading = true
        state.error = null
        state.itemDetails = {}
      })
      .addCase(getItemsDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action?.payload

        if (status) {
          state.itemDetails = data
        }
      })
      .addCase(getItemsDetails.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE ITEM
    builder
      .addCase(updateItem.pending, state => {
        //
        state.error = null
        state.isLoading = true
        state.actionType = null
        state.message = null
      })
      .addCase(updateItem.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          state.actionType = "UPDATED_ITEM_SUCCESS"
          state.message = action.payload.msg
        } else {
          state.actionType = "UPDATED_ITEM_FAILED"
          state.error = action.payload.msg
        }
      })
      .addCase(updateItem.rejected, (state, action) => {
        state.isLoading = false
      })

    // DELETE Item
    builder
      .addCase(deleteItem.pending, state => {
        state.error = null
        state.isLoading = true
        state.actionType = null
      })
      .addCase(deleteItem.fulfilled, (state, action) => {
        const { status, msg } = action.payload
        const { id, setShowDeleteModal } = action.meta.arg
        state.isLoading = false
        if (status) {
          // state.itemDetails = state.itemDetails.modifierGroups.filter(
          //   item => item._id !== id
          // )
          state.itemsLists = state.itemsLists.filter(item => item._id !== id)
          state.error = null
          state.actionType = "ITEM_DELETE_SUCCESS"
          state.message = msg
          setShowDeleteModal(false)
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        } else {
          state.actionType = "ITEM_DELETE_FAILED"
          state.error = msg
        }
      })
      .addCase(deleteItem.rejected, (state, action) => {
        state.isLoading = false
      })

    // DELETE ITEM MODIFIER GROUP
    builder
      .addCase(deleteModifierGroup.pending, state => {
        state.error = null
        state.isLoading = true
        state.actionType = null
      })
      .addCase(deleteModifierGroup.fulfilled, (state, action) => {
        const { status, msg } = action.payload
        const { id, setShowDeleteModal } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.itemDetails.modifierGroups =
            state.itemDetails.modifierGroups.filter(group => group._id !== id)
          state.error = null
          state.actionType = "MODIFIER_GROUP_DELETE_SUCCESS"
          state.message = msg
          setShowDeleteModal(false)
        } else {
          state.actionType = "MODIFIER_GROUP_DELETE_FAILED"
          state.error = msg
        }
      })
      .addCase(deleteModifierGroup.rejected, (state, action) => {
        state.isLoading = false
      })

    // DELETE MULTIPLE ITEMS
    builder
      .addCase(deleteMultipleItems.pending, state => {
        state.error = null
        state.isLoading = true
      })
      .addCase(deleteMultipleItems.fulfilled, (state, action) => {
        const { status } = action.payload
        const { ids } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.itemsLists = state.itemsLists.filter(
            item => !ids.includes(item._id)
          )
        }
      })
      .addCase(deleteMultipleItems.rejected, (state, action) => {
        state.isLoading = false
      })

    // UPDATE MULTIPLE ITEMS
    builder
      .addCase(updateMultipleItems.pending, state => {
        state.error = null
        state.isLoading = true
      })
      .addCase(updateMultipleItems.fulfilled, (state, action) => {
        const { status } = action.payload
        const { selectedActionType } = action.meta.arg
        const { ids } = action.meta.arg.payload
        state.isLoading = false
        if (status) {
          if (
            selectedActionType === "ACTIVE" ||
            selectedActionType === "DEACTIVATE"
          ) {
            state.itemsLists = state.itemsLists.map(item => {
              if (ids.includes(item._id)) {
                return {
                  ...item,
                  status: selectedActionType === "ACTIVE" ? 1 : 0,
                }
              }
              return item
            })
          }
        }
      })
      .addCase(updateMultipleItems.rejected, (state, action) => {
        state.isLoading = false
      })

    // Add Gallery Images
    builder
      .addCase(addGalleryImages.pending, state => {
        state.isLoading = true
      })
      .addCase(addGalleryImages.fulfilled, (state, action) => {
        const { status } = action.payload
        state.isLoading = false
        if (status) {
          // console.log(status)
          // console.log(action.payload)
        }
      })
      .addCase(addGalleryImages.rejected, (state, action) => {
        state.isLoading = false
      })

    // Add Video
    builder
      .addCase(addVideo.pending, state => {
        state.isLoading = true
      })
      .addCase(addVideo.fulfilled, (state, action) => {
        const { status, data } = action?.payload

        state.isLoading = false
        if (status) {
          const newItem = { ...state.itemDetails, videoUrl: data }
          // console.log(newItem)
          state.itemDetails = newItem
        }
      })
      .addCase(addVideo.rejected, (state, action) => {
        state.isLoading = false
      })

    // Remove Vide URL
    builder
      .addCase(removeVideoUrlFromItem.pending, state => {})
      .addCase(removeVideoUrlFromItem.fulfilled, (state, action) => {
        const updatedItem = { ...state.itemDetails, videoUrl: "" }
        state.itemDetails = updatedItem
      })
      .addCase(removeVideoUrlFromItem.rejected, (state, action) => {})

    // CLONE ITEM
    // Add Video
    builder
      .addCase(cloneItem.pending, state => {
        state.isLoading = true
      })
      .addCase(cloneItem.fulfilled, (state, action) => {
        const { status, data } = action?.payload

        state.isLoading = false
        console.log(data)
        state.itemsLists = [...state.itemsLists, data]
      })
      .addCase(cloneItem.rejected, (state, action) => {
        state.isLoading = false
      })

    // CALCULATIONS COMBO PRICE
    builder
      .addCase(calculateComboPrice.pending, state => {
        state.isLoading = true
      })
      .addCase(calculateComboPrice.fulfilled, (state, action) => {
        const { status, data } = action?.payload
        state.isLoading = false
      })
      .addCase(calculateComboPrice.rejected, (state, action) => {
        state.isLoading = false
      })

    // ENABLE DISABLE ITEM
    builder
      .addCase(enableDisableItem.pending, state => {
        state.isLoading = true
      })
      .addCase(enableDisableItem.fulfilled, (state, action) => {
        const { status, data } = action.payload // Extract status and data from action.payload
        const { id, branchId, fieldName, status: itemStatus } = action.meta.arg // Extract id, branchId, fieldName, and itemStatus from action.meta.arg

        if (status) {
          // We only want to proceed with the update if the status is true
          state.itemsLists = state.itemsLists.map(item => {
            if (item._id === id) {
              // Dynamically update the field (outOfStockForBranches or disabledBranches)
              const updatedField = itemStatus
                ? [...item[fieldName], branchId] // Add branchId if status is true
                : item[fieldName].filter(bId => bId !== branchId) // Remove branchId if status is false

              return {
                ...item,
                [fieldName]: updatedField, // Update the field dynamically
              }
            }
            return item // Return unchanged items for others
          })

          state.isLoading = false
        }
      })
      .addCase(enableDisableItem.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export const { removeVideoUrlItem } = usersSlice.actions

export default usersSlice.reducer
